// SCT Summary — the screen's strings in the portal's four languages (2026-10-21). On-screen only: the import
// template, the export and the importer's column headings are built on the server and stay as they are.
const en = {
  pageSub: 'Standard cycle time by SAP code, from every OPA document',
  col: {
    season: 'Season',
    line: 'Line',
    category: 'Category',
    sap: 'SAP Code',
    styleName: 'Style Name',
    productionName: 'Production Name',
    colorway: 'Colorway',
    frameColor: 'Frame Color',
    varTotal: 'ΣVariable Sewing Cycles',
    stdTotal: 'ΣStandard Work Subtotal',
    frameFit: 'Frame-Fit CT (h)',
    frameAss: 'Frame ass. CT (h)',
    packaging: 'Packaging CT (h)',
    efficiency: 'Style Efficiency',
    indirectHours: 'Indirect Rate (h)',
  },
  groupVar: 'Variable Sewing Cycles',
  groupStd: 'Standard Work Subtotal',
  errSave: 'Could not save',
  errDelete: 'Could not delete',
  errExport: 'Export failed',
  errLoad: 'Could not load the SCT table',
  errRead: 'Could not read that file',
  errImport: 'The import failed',
  search: 'Search SAP code, style, colorway',
  noSeason: 'no season imported yet',
  seasonOpt: '{{season}} — {{n}} SKU',
  exportXlsx: 'Export .xlsx',
  importXlsx: 'Import .xlsx',
  importFormat: 'Import format',
  loading: 'Loading…',
  refresh: 'Refresh',
  clear: 'Clear',
  planMeta_one: 'season {{seasons}} · sheet "{{sheet}}" · {{total}} rows',
  planMeta_other: 'seasons {{seasons}} · sheet "{{sheet}}" · {{total}} rows',
  willImport: '{{n}} will be imported.',
  dupes: '{{n}} already exist and will NOT be imported — they come back as a file so you can see what differs.',
  more: '+{{n}} more',
  importing: 'Importing…',
  importN: 'Import {{n}} rows',
  cancel: 'Cancel',
  imported: 'Imported {{n}} rows.',
  importedInto: 'Imported {{n}} rows into {{seasons}}.',
  skippedDl: '{{n}} duplicates were not imported — {{file}} has been downloaded.',
  dismiss: 'Dismiss',
  viewOnly: 'View only',
  idSap: 'SAP code',
  idStyle: 'Style name',
  idSeason: 'Season',
  idLine: 'Line',
  idCategory: 'Category',
  idColorway: 'Colorway',
  idFrameColor: 'Frame Color',
  idNote: 'from Style Hub — not editable here',
  opa: 'OPA',
  noLongerActive: '{{doc}} (no longer active)',
  opaPlaceholder: 'Type a number or a style name — e.g. chair one',
  none: '— none —',
  noDocMatch: 'No document matches "{{q}}"',
  moreDocs: '{{n}} more — keep typing to narrow it',
  notMeasured: 'blank = not measured',
  saving: 'Saving…',
  save: 'Save',
  close: 'Close',
  dropTitle: 'Delete this row?',
  dropWhat: '{{sap}} — {{style}}, season {{season}}.',
  dropNote: 'Its cycle times go with it. Nothing else on the SKU changes, and the row comes back if the season is imported again.',
  deleting: 'Deleting…',
  delete: 'Delete',
  no: 'No',
  action: 'Action',
  viewTitle: 'View this row (read only)',
  view: 'View',
  edit: 'Edit',
  empty: 'No SCT rows for this season yet — import the season workbook to start.',
};

const ko = {
  pageSub: '모든 OPA 문서에서 집계한 SAP 코드별 표준 사이클 타임',
  col: {
    season: '시즌',
    line: '라인',
    category: '카테고리',
    sap: 'SAP 코드',
    styleName: '스타일명',
    productionName: '생산명',
    colorway: '컬러웨이',
    frameColor: '프레임 컬러',
    varTotal: 'Σ가변 봉제 사이클',
    stdTotal: 'Σ표준 작업 소계',
    frameFit: '프레임 피팅 CT (h)',
    frameAss: '프레임 조립 CT (h)',
    packaging: '포장 CT (h)',
    efficiency: '스타일 효율',
    indirectHours: '간접 비율 (h)',
  },
  groupVar: '가변 봉제 사이클',
  groupStd: '표준 작업 소계',
  errSave: '저장하지 못했습니다',
  errDelete: '삭제하지 못했습니다',
  errExport: '내보내기에 실패했습니다',
  errLoad: 'SCT 표를 불러오지 못했습니다',
  errRead: '파일을 읽지 못했습니다',
  errImport: '가져오기에 실패했습니다',
  search: 'SAP 코드, 스타일, 컬러웨이 검색',
  noSeason: '가져온 시즌이 아직 없습니다',
  seasonOpt: '{{season}} — {{n}} SKU',
  exportXlsx: '.xlsx 내보내기',
  importXlsx: '.xlsx 가져오기',
  importFormat: '가져오기 양식',
  loading: '불러오는 중…',
  refresh: '새로고침',
  clear: '초기화',
  planMeta_one: '시즌 {{seasons}} · 시트 "{{sheet}}" · {{total}}행',
  planMeta_other: '시즌 {{seasons}} · 시트 "{{sheet}}" · {{total}}행',
  willImport: '{{n}}행을 가져옵니다.',
  dupes: '{{n}}행은 이미 있어 가져오지 않습니다 — 무엇이 다른지 볼 수 있도록 파일로 돌려드립니다.',
  more: '+{{n}}개 더',
  importing: '가져오는 중…',
  importN: '{{n}}행 가져오기',
  cancel: '취소',
  imported: '{{n}}행을 가져왔습니다.',
  importedInto: '{{seasons}}에 {{n}}행을 가져왔습니다.',
  skippedDl: '중복 {{n}}행은 가져오지 않았습니다 — {{file}} 파일을 내려받았습니다.',
  dismiss: '닫기',
  viewOnly: '보기 전용',
  idSap: 'SAP 코드',
  idStyle: '스타일명',
  idSeason: '시즌',
  idLine: '라인',
  idCategory: '카테고리',
  idColorway: '컬러웨이',
  idFrameColor: '프레임 컬러',
  idNote: 'Style Hub 정보 — 여기서는 수정할 수 없습니다',
  opa: 'OPA',
  noLongerActive: '{{doc}} (더 이상 활성 아님)',
  opaPlaceholder: '번호나 스타일명을 입력하세요 — 예: chair one',
  none: '— 없음 —',
  noDocMatch: '"{{q}}"와 일치하는 문서가 없습니다',
  moreDocs: '{{n}}개 더 — 계속 입력해 범위를 좁히세요',
  notMeasured: '빈칸 = 측정 안 됨',
  saving: '저장 중…',
  save: '저장',
  close: '닫기',
  dropTitle: '이 행을 삭제할까요?',
  dropWhat: '{{sap}} — {{style}}, 시즌 {{season}}.',
  dropNote: '이 행의 사이클 타임도 함께 삭제됩니다. SKU의 다른 정보는 바뀌지 않으며, 시즌을 다시 가져오면 행이 돌아옵니다.',
  deleting: '삭제 중…',
  delete: '삭제',
  no: 'No',
  action: '작업',
  viewTitle: '이 행 보기(읽기 전용)',
  view: '보기',
  edit: '수정',
  empty: '이 시즌의 SCT 행이 아직 없습니다 — 시즌 워크북을 가져와 시작하세요.',
};

const vi = {
  pageSub: 'Thời gian chu kỳ chuẩn theo mã SAP, từ mọi tài liệu OPA',
  col: {
    season: 'Mùa',
    line: 'Dòng hàng',
    category: 'Danh mục',
    sap: 'Mã SAP',
    styleName: 'Tên style',
    productionName: 'Tên sản xuất',
    colorway: 'Phối màu',
    frameColor: 'Màu khung',
    varTotal: 'ΣChu kỳ may biến đổi',
    stdTotal: 'ΣTiểu tổng công việc chuẩn',
    frameFit: 'CT gắn khung (h)',
    frameAss: 'CT lắp ráp khung (h)',
    packaging: 'CT đóng gói (h)',
    efficiency: 'Hiệu suất style',
    indirectHours: 'Tỷ lệ gián tiếp (h)',
  },
  groupVar: 'Chu kỳ may biến đổi',
  groupStd: 'Tiểu tổng công việc chuẩn',
  errSave: 'Không lưu được',
  errDelete: 'Không xóa được',
  errExport: 'Xuất thất bại',
  errLoad: 'Không tải được bảng SCT',
  errRead: 'Không đọc được file này',
  errImport: 'Nhập thất bại',
  search: 'Tìm mã SAP, style, phối màu',
  noSeason: 'chưa nhập mùa nào',
  seasonOpt: '{{season}} — {{n}} SKU',
  exportXlsx: 'Xuất .xlsx',
  importXlsx: 'Nhập .xlsx',
  importFormat: 'Mẫu nhập',
  loading: 'Đang tải…',
  refresh: 'Làm mới',
  clear: 'Xóa lọc',
  planMeta_one: 'mùa {{seasons}} · sheet "{{sheet}}" · {{total}} dòng',
  planMeta_other: 'các mùa {{seasons}} · sheet "{{sheet}}" · {{total}} dòng',
  willImport: '{{n}} dòng sẽ được nhập.',
  dupes: '{{n}} dòng đã có và sẽ KHÔNG được nhập — chúng được trả lại thành file để bạn xem khác nhau ở đâu.',
  more: '+{{n}} nữa',
  importing: 'Đang nhập…',
  importN: 'Nhập {{n}} dòng',
  cancel: 'Hủy',
  imported: 'Đã nhập {{n}} dòng.',
  importedInto: 'Đã nhập {{n}} dòng vào {{seasons}}.',
  skippedDl: '{{n}} dòng trùng không được nhập — đã tải về {{file}}.',
  dismiss: 'Đóng',
  viewOnly: 'Chỉ xem',
  idSap: 'Mã SAP',
  idStyle: 'Tên style',
  idSeason: 'Mùa',
  idLine: 'Dòng hàng',
  idCategory: 'Danh mục',
  idColorway: 'Phối màu',
  idFrameColor: 'Màu khung',
  idNote: 'lấy từ Style Hub — không sửa được ở đây',
  opa: 'OPA',
  noLongerActive: '{{doc}} (không còn hoạt động)',
  opaPlaceholder: 'Gõ số hoặc tên style — ví dụ: chair one',
  none: '— không có —',
  noDocMatch: 'Không có tài liệu nào khớp "{{q}}"',
  moreDocs: 'còn {{n}} — gõ tiếp để thu hẹp',
  notMeasured: 'để trống = chưa đo',
  saving: 'Đang lưu…',
  save: 'Lưu',
  close: 'Đóng',
  dropTitle: 'Xóa dòng này?',
  dropWhat: '{{sap}} — {{style}}, mùa {{season}}.',
  dropNote: 'Các thời gian chu kỳ của dòng sẽ bị xóa theo. Không có gì khác trên SKU thay đổi, và dòng sẽ trở lại nếu mùa được nhập lại.',
  deleting: 'Đang xóa…',
  delete: 'Xóa',
  no: 'STT',
  action: 'Thao tác',
  viewTitle: 'Xem dòng này (chỉ xem)',
  view: 'Xem',
  edit: 'Sửa',
  empty: 'Mùa này chưa có dòng SCT nào — hãy nhập workbook của mùa để bắt đầu.',
};

const zh = {
  pageSub: '按 SAP 代码汇总的标准周期时间，来自所有 OPA 文档',
  col: {
    season: '季',
    line: '产品线',
    category: '类别',
    sap: 'SAP 代码',
    styleName: '款式名称',
    productionName: '生产名称',
    colorway: '配色',
    frameColor: '框架颜色',
    varTotal: 'Σ可变缝制周期',
    stdTotal: 'Σ标准作业小计',
    frameFit: '套框 CT (h)',
    frameAss: '框架组装 CT (h)',
    packaging: '包装 CT (h)',
    efficiency: '款式效率',
    indirectHours: '间接率 (h)',
  },
  groupVar: '可变缝制周期',
  groupStd: '标准作业小计',
  errSave: '无法保存',
  errDelete: '无法删除',
  errExport: '导出失败',
  errLoad: '无法加载 SCT 表',
  errRead: '无法读取该文件',
  errImport: '导入失败',
  search: '搜索 SAP 代码、款式、配色',
  noSeason: '尚未导入任何季',
  seasonOpt: '{{season}} — {{n}} SKU',
  exportXlsx: '导出 .xlsx',
  importXlsx: '导入 .xlsx',
  importFormat: '导入模板',
  loading: '加载中…',
  refresh: '刷新',
  clear: '清除',
  planMeta_one: '季 {{seasons}} · 工作表 "{{sheet}}" · {{total}} 行',
  planMeta_other: '季 {{seasons}} · 工作表 "{{sheet}}" · {{total}} 行',
  willImport: '将导入 {{n}} 行。',
  dupes: '{{n}} 行已存在，将不会导入——它们会以文件形式返回，方便您查看差异。',
  more: '+{{n}} 条',
  importing: '导入中…',
  importN: '导入 {{n}} 行',
  cancel: '取消',
  imported: '已导入 {{n}} 行。',
  importedInto: '已导入 {{n}} 行到 {{seasons}}。',
  skippedDl: '{{n}} 行重复未导入——已下载 {{file}}。',
  dismiss: '关闭',
  viewOnly: '仅查看',
  idSap: 'SAP 代码',
  idStyle: '款式名称',
  idSeason: '季',
  idLine: '产品线',
  idCategory: '类别',
  idColorway: '配色',
  idFrameColor: '框架颜色',
  idNote: '来自 Style Hub——此处不可编辑',
  opa: 'OPA',
  noLongerActive: '{{doc}}（已停用）',
  opaPlaceholder: '输入编号或款式名称——例如 chair one',
  none: '— 无 —',
  noDocMatch: '没有与 "{{q}}" 匹配的文档',
  moreDocs: '还有 {{n}} 个——继续输入以缩小范围',
  notMeasured: '留空 = 未测量',
  saving: '保存中…',
  save: '保存',
  close: '关闭',
  dropTitle: '删除此行？',
  dropWhat: '{{sap}} — {{style}}，季 {{season}}。',
  dropNote: '该行的周期时间会一并删除。SKU 的其他信息不变，若重新导入该季，此行会回来。',
  deleting: '删除中…',
  delete: '删除',
  no: '序号',
  action: '操作',
  viewTitle: '查看此行（只读）',
  view: '查看',
  edit: '编辑',
  empty: '此季尚无 SCT 行——请导入该季的工作簿开始。',
};

const dictionary = { ns: 'xSct', en, ko, vi, zh };

export default dictionary;
